/*
* Drawing functions for Sample Graph, all in one convenient location.
*
*/

(function (SG, window, undefined) {
  _.extend(SG.prototype, {
    // given a canvas y coord, draw a dashed horizontal line
    // nice to draw at 0 for grade, or a goal speed, etc
    drawHorizontalLine: function(y, strokeStyle) {
      var ctx = this.ctx,
        pmd = this.plotMetaData[this.xAxisType()],
        left = this.plotToPixel(pmd.min),
        right = this.plotToPixel(pmd.max);
      ctx.beginPath();
      // lets draw a dashed line
      var dashLen = 6, spacing = 6;
      while(left + dashLen <= right) {
        ctx.moveTo(left, y);
        left += dashLen;
        ctx.lineTo(left, y);
        left += spacing;
      }
      if(strokeStyle) {
        ctx.strokeStyle = strokeStyle;
        ctx.stroke();
        ctx.restore(); ctx.save();
      } else {
        ctx.stroke();
      }
    },

    drawXAxis: function() {
      var conf = this.xAxisConfig();
      var top = this.height() - this.plotMargin().bottom;
      var xAxisType = this.xAxisType();
      var metric = this.metrics(xAxisType);
      var inverseConversionFn = metric.inverseConvert;
      var pmd = this.plotMetaData[xAxisType];
      var min = pmd.min;
      var max = pmd.max;
      var tickValues = pmd.tickValues;
      var numTicks = tickValues.length;
      var ctx = this.ctx;
      var right = this.plotToPixel(max);
      var left = this.plotToPixel(min);
      var baselineYOffset = top + conf.lineSideMargin;
      var label;

      ctx.beginPath();
      // axis line
      ctx.moveTo(left, baselineYOffset);
      ctx.lineTo(right, baselineYOffset);
      // tick marks with labels
      for(var i=0;i < numTicks; i++) {
        var x;
        var convertedPlotVal = tickValues[i];
        var plotVal = inverseConversionFn(tickValues[i]);
        x = this.plotToPixel(plotVal);
        var height = conf.innerTicksLength;
        var tickEndY = baselineYOffset + height;
        ctx.moveTo(x, baselineYOffset);
        ctx.lineTo(x, tickEndY);
        // label
        label = this.formatNumber(convertedPlotVal, xAxisType);
        this.placeText(label, x, Math.round(baselineYOffset + conf.tickLabelMargin), {align: 'center'});
      }
      // center the label
      label = this.xAxisLabel();

      if(this.get('showXAxisLabel')) {
        this.placeText(label, this.plotWidth / 2 + this.plotMargin().left, baselineYOffset + conf.innerTicksLength + conf.tickLabelMargin + conf.tickLabelTextHeight, {align: 'center'});
      }
      ctx.stroke();
    },

    xAxisLabel: function() {
      var label, xAxisType = this.xAxisType();
      var otherxaxis = xAxisType == 'distance' ? 'time' : 'distance';
      if(xAxisType == 'distance')
        label = T.t('sample_graph.distance_in') + ' ' + T.t('sample_graph.' + SG.unitsFor(xAxisType));
      else
        label = T.t('sample_graph.time_from_start');
      if(this.metricsX().length == 2) {
        label += " (<a href='javascript:;' class='sample-graph-x-axis-use-" +
          otherxaxis +
          "'>" + T.t('sample_graph.switch_to') + ' ' + T.t('sample_graph.' + otherxaxis) + "</a>)";

      }
      return label;
    },

    placeText: function(html, canvasX, canvasY, opts) {
      if(!opts) opts = {};
      var pageCoords = this.canvasToPageCoords(canvasX, canvasY);
      var $text = $('<span>' + html + '</span>')
        .addClass(this.uniqueClass)
        .addClass('sg-elem')
        .addClass('sample-graph-render-text')
        .css({zIndex: this.zIndex()})
        .prependTo(this.$canvas.parent());
      switch(opts.align) {
      case 'center':
        pageCoords.x -= $text.width() / 2;
        break;
      case 'right':
        pageCoords.x -= $text.width();
        break;
      }
      switch(opts.vAlign) {
      case 'middle':
        pageCoords.y -= $text.height() / 2 - 1;
      }
      $text.offset({top: pageCoords.y, left: pageCoords.x});
      return $text;
    },

    drawYAxis: function(metric, left) {
      if (metric === 'surfaces') {
        // surfaces goes on the ele profile, not the y axis
        return
      }
      var metricObj = this.metrics(metric);
      var baseMetric = metricObj.baseMetricKey();
      var right = left + this.yAxisWidth;
      var onLeft = left < this.width() / 2;

      var inverseConversionFn = metricObj.inverseConvert;
      var tickValues = this.plotMetaData[metric].tickValues;
      var numTicks = tickValues.length;

      var min = this.plotMetaData[metric].min;
      var max = this.plotMetaData[metric].max;

      var outerTicksLength = 6;
      var innerTicksLength = 4;
      var lineSideMargin = 0;
      var tickLabelMargin = 2;
      var ctx = this.ctx;

      var top = this.plotToPixel(null, max, metric);
      var bottom = this.plotToPixel(null, min, metric);

      // use the same code to draw left or right side yaxis, basically just mirroring it with these vars
      var verticalLineXOffset = onLeft ? right - lineSideMargin : left + lineSideMargin;
      var tickDirectionMult = onLeft ? -1 : 1

      ctx.beginPath();
      var strokeStyle = this.strokeStyle(baseMetric);
      if(strokeStyle && metric != 'ele') { // hack hack to make ele black black
        ctx.strokeStyle = strokeStyle;
        ctx.fillStyle = strokeStyle;
      }

      // axis line
      ctx.moveTo(verticalLineXOffset, top);
      ctx.lineTo(verticalLineXOffset, bottom);
      // tick marks with labels
      for(var i=0;i < numTicks; i++) {
        var convertedPlotVal = tickValues[i];
        var plotVal = inverseConversionFn(convertedPlotVal);
        var y;
        if(metric != 'ele' && i == 0) // snap tick to bottom (except if ele -- its tightly labeled on bottom end)
          y = bottom;
        else if(i == (numTicks - 1)) // snap tick to top
          y = top;
        else // its an in-between tick so just draw it in the right place
          y = this.plotToPixel(null, plotVal, metric);
        var width = i == 0 || i == (numTicks-1) ? outerTicksLength : innerTicksLength;
        var tickEndX = verticalLineXOffset + tickDirectionMult * width;
        ctx.moveTo(verticalLineXOffset, y);
        ctx.lineTo(tickEndX, y);
        // label
        var label = this.formatNumber(convertedPlotVal, metric);
        this.placeText(label, tickEndX + tickDirectionMult * tickLabelMargin, y, {align: (onLeft ? 'right' : 'left'), vAlign: 'middle'});
      }
      // axis unit label
      var axisLabelMargin = 5;
      var bottomLabelSpaceFromLine = 3;
      label = T.t('sample_graph.' + baseMetric) + '<br>(' + T.t('sample_graph.' + SG.unitsFor(baseMetric)) + ')';
      this.placeText(label, verticalLineXOffset + tickDirectionMult * bottomLabelSpaceFromLine, bottom + axisLabelMargin, {align: (onLeft ? 'right' : 'left')})

      ctx.stroke();
      ctx.restore(); ctx.save();
    },

    clearBeforeRender: function() {
      this.ctx.clearRect(0, 0, this.$canvas.width(), this.$canvas.height());
      $('.' + this.uniqueClass + '.sample-graph-render-text').remove();
    },

    // This is not intended as a robust charting solution - it's for generating SVGs
    // for use in ride posters. If you're thinking of using it for something else
    // refactor it first.
    makeSVG: function(metric) {
      const plotHeight = 200
      const plotWidth = 1000
      const padding = 75;
      const data = this.dataToRender()
      const xAxisType = 'distance'

      const nice = (a, rounding) => {
        if (a === 0) return 0
        let x = a
        // if x is negative, correct it
        let negative = 1
        if (x < 0) {
          x = x * -1
          negative = -1
        }
        // get order of magnitude
        const bigness = Math.pow(10, Math.floor(Math.log10(x)))
        // convert to an value in the range (0, 10)
        const i = x / bigness
        // round to a multiple of 0.5 or 5 depending on size
        const round = (i < 5) ? 0.5 : 5
        let j = Math[rounding](i / round)
        // re-scale
        return bigness * j * round * negative
      }
      const xMetricObj = this.metrics(xAxisType)
      const xNice = (x, rounding) => xMetricObj.inverseConvert(nice(xMetricObj.convert(x), rounding))
      const xMin = xNice(data[0][xAxisType], 'floor')
      const xMax = data[data.length-1][xAxisType]
      const xRatio = (plotWidth) / (xMax - xMin)

      const yMetricObj = this.metrics(metric)
      const yNice = (x, rounding) => yMetricObj.inverseConvert(nice(yMetricObj.convert(x), rounding))
      const yMin = yNice(this.plotMetaData[metric].min, 'floor')
      const yMax = yNice(this.plotMetaData[metric].max, 'ceil')
      const yRatio = (plotHeight) / (yMax - yMin)

      const node = tag => document.createElementNS("http://www.w3.org/2000/svg", tag)

      const svg = node('svg')
      const plot = node('path')

      const xScale = (x) => x * xRatio
      const yScale = (y) => (plotHeight - (y - yMin) * yRatio)

      svg.setAttribute('width', plotWidth + 2 * padding)
      svg.setAttribute('height', plotHeight + 2 * padding)

      const scaledPoints = data.map(point => {
        const x = xScale(point[xAxisType])
        const y = yScale(point[metric])
        return x + ',' + y
      })
      const points = [`0,${plotHeight}`, ...scaledPoints, `${plotWidth},${plotHeight}`]
      plot.setAttribute('d', `M${points.join('L')}Z`)
      plot.setAttribute("fill", '#ffb370')
      plot.setAttribute("stroke", '#f70')
      plot.setAttribute("stroke-width", 2)
      plot.setAttribute("transform", `translate(${padding}, ${padding})`)

      const xAxisGroup = node('g')
      xAxisGroup.setAttribute("transform", `translate(${padding},${padding + plotHeight + 10})`)
      const xAxis = node('path')
      xAxis.setAttribute('d', `M0,0H${plotWidth}`)
      xAxis.setAttribute("stroke", '#bbb')
      xAxis.setAttribute("stroke-width", 2)
      xAxisGroup.appendChild(xAxis)

      const xAxisLabels = node('g')
      xAxisLabels.setAttribute("transform", `translate(${padding},${padding + plotHeight + 27})`)
      xAxisLabels.setAttribute("style", 'fill: #bbb; font-family: Helvetica, sans-serif; font-size: 12px;')

      const xInt = xNice((xMax - xMin) / 8, 'round') // we want at least 8 tickmarks
      for (let i = 0; i * xInt < xMax; i++) {
        const x = xScale(xMin + xInt * i)
        const tick = node('path')
        tick.setAttribute("stroke", '#bbb')
        tick.setAttribute("stroke-width", 2)
        tick.setAttribute('transform', `translate(${x},0)`)
        tick.setAttribute('d', 'M0,0V5')
        xAxisGroup.appendChild(tick)

        const label = node('text')
        const distance = this.metrics('distance').convert(xMin + xInt * i)
        label.textContent = this.formatNumber(distance, 'distance')
        label.setAttribute('transform', `translate(${x},0)`)
        label.setAttribute('text-anchor', 'middle')
        xAxisLabels.appendChild(label)
      }

      const xAxisUnits = node('text')
      xAxisUnits.textContent = `distance (${SG.unitsFor(xAxisType)})`
      xAxisUnits.setAttribute('transform', `translate(${plotWidth/2},20)`)
      xAxisUnits.setAttribute('text-anchor', 'middle')
      xAxisLabels.appendChild(xAxisUnits)

      const yAxisGroup = node('g')
      yAxisGroup.setAttribute("transform", `translate(${padding - 10},${padding})`)
      const yAxis = node('path')
      yAxis.setAttribute('d', `M0,0V${plotHeight}`)
      yAxis.setAttribute("stroke", '#bbb')
      yAxis.setAttribute("stroke-width", 2)
      yAxisGroup.appendChild(yAxis)

      const yAxisLabels = node('g')
      yAxisLabels.setAttribute("transform", `translate(${padding - 18},${padding + 4})`)
      yAxisLabels.setAttribute("style", 'fill: #bbb; font-family: Helvetica, sans-serif; font-size: 12px;')

      // calculate the distance between tick marks by rounding 1/4 of the range
      // of the data to the nearest multiple of 1, 5, or 10
      const yInt = (yMax - yMin) / 4
      for (let i = 0; i <= 4; i++) {
        const y = yScale(yMin + yInt * i)
        const tick = node('path')
        tick.setAttribute("stroke", '#bbb')
        tick.setAttribute("stroke-width", 2)
        tick.setAttribute('transform', `translate(0,${y})`)
        tick.setAttribute('d', 'M0,0H-5')
        yAxisGroup.appendChild(tick)

        const label = node('text')
        const m = this.metrics(metric).convert(yMin + yInt * i)
        label.textContent = this.formatNumber(m, metric)
        label.setAttribute('transform', `translate(0,${y})`)
        label.setAttribute('text-anchor', 'end')
        yAxisLabels.appendChild(label)
      }

      const yAxisUnits = node('text')
      yAxisUnits.textContent = `elevation (${SG.unitsFor(metric)})`
      yAxisUnits.setAttribute('transform', `translate(-40,${plotHeight/2}) rotate(90)`)
      yAxisUnits.setAttribute('text-anchor', 'middle')
      yAxisLabels.appendChild(yAxisUnits)


      svg.appendChild(plot)
      svg.appendChild(xAxisGroup)
      svg.appendChild(xAxisLabels)
      svg.appendChild(yAxisGroup)
      svg.appendChild(yAxisLabels)
      return svg
    },

    unpavedPattern: function () {
      if (this._unpavedPatternCanvas) {
        return this._unpavedPatternCanvas
      }

      const patternCanvas = document.createElement('canvas');
      const patternContext = patternCanvas.getContext('2d');

      patternCanvas.width = 10;
      patternCanvas.height = 5;

      patternContext.fillStyle = '#FAEFEE';
      patternContext.fillRect(0, 0, 4, patternCanvas.height);
      patternContext.fillStyle = '#cf635a';
      patternContext.fillRect(4, 0, patternCanvas.width, patternCanvas.height);
      patternContext.stroke();

      this._unpavedPatternCanvas = patternCanvas
      return this._unpavedPatternCanvas
    },

    // draw indicated plot only
    drawPlot: function(metric) {
      if (metric === 'surfaces') {
        // surfaces is drawn by ele
        return;
      }

      var ctx = this.ctx,
        width = this.plotWidth,
        data = this.dataToRender(),
        len = data.length,
        xAxisType = this.xAxisType(),
        xMin = data[0][xAxisType],
        xMax = data[len-1][xAxisType],
        xRatio = width / (xMax - xMin),
        strokeStyle = this.strokeStyle(metric),
        filters = this.filters(),
        fillStyle = this.fillStyle(metric);
      this.xRatio = isFinite(xRatio) ? xRatio : 0;
      this.xMin = xMin;

      // if we're drawing pen is down, draw lines.  otherwise pen is up, so moveto
      var drawing = false;
      var filter = filters[metric];
      var bottom = this.plotMargin().top + this.plotHeight;
      var startX;
      var x, y;
      var closePath = () => {
        ctx.lineTo(x, y)
        if (fillStyle) {
          ctx.lineTo(x, bottom)
          ctx.lineTo(startX, bottom)
          ctx.fillStyle = fillStyle
          ctx.fill()
        }
        ctx.strokeStyle = strokeStyle
        ctx.stroke()
        ctx.closePath()
      }
      for(var i=0; i < len; i++) {
        var dCurr = data[i][metric];
        if(dCurr === undefined || dCurr === null || filter && !filter(dCurr)) {
          // if there is a fill style, we don't want to quit drawing.
          // instead, we'll draw a straight line to the next point.
          if(drawing && !fillStyle) {
            closePath()
            drawing = false;
          }
          continue;
        }
        x = this.plotToPixel(data[i][xAxisType]);
        y = this.plotToPixel(null, dCurr, metric);

        if (metric === 'ele') {
          if (data[i].excludeFromMetrics && (i === 0 || !data[i-1].excludeFromMetrics)) {
            // beginning a section of elevation that is excluded from metrics, it will show up grey.
            // fill in the elevation profile up to this point, then start the excluded section
            if (i > 0) closePath();
            fillStyle = this.fillStyle('excluded');
            strokeStyle = this.strokeStyle('excluded');
            drawing = false;
          } else if (i < (len - 1) && data[i].excludeFromMetrics && !data[i+1].excludeFromMetrics) {
            // ending a section of elevation that is excluded from metrics. revert to standard elevation styling
            // after filling in the grey excluded section
            closePath();
            if (this.showSurface()) {
              const surfaceGroups = rwgps.surfaces && rwgps.surfaces.surfaceGroups
              const group = surfaceGroups[data[i].surface]
              fillStyle = this.fillStyle(group)
            } else {
              fillStyle = this.fillStyle('ele')
            }
            strokeStyle = this.strokeStyle('ele');
            drawing = false;
          } else if (!data[i].excludeFromMetrics && this.showSurface()) {
            // this is handled last so that excluded style takes prescedence
            const surfaceGroups = rwgps.surfaces && rwgps.surfaces.surfaceGroups;
            const lastGroup = data[i - 1] && surfaceGroups[data[i - 1].surface];
            const group = data[i] && surfaceGroups[data[i].surface];

            if ((lastGroup && group !== lastGroup) || i === 0) {
              if (i > 0) closePath();
              fillStyle = this.fillStyle(group);
              strokeStyle = this.strokeStyle('ele');
              drawing = false;
            }
          }
        }

        if(!drawing) {
          startX = x;
          ctx.beginPath();
          ctx.moveTo(x, y);
          drawing = true;
        } else {
          ctx.lineTo(x, y);
        }
      }
      if (drawing) {
        closePath()
      }
      ctx.restore(); ctx.save();
    }
  });
})(SampleGraph, window);



// WEBPACK FOOTER //
// ./public/javascripts/sample_graph/sample_graph.drawing.js